import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
} from "@material-ui/core";
import { useStore } from "@store/store";
import Pagination from "@components/pagination";
import { impactedJobsListingHeader, routes, rowsPerPageVal } from "@utils/constant";
import { TableStyle } from "./style";
import { utcToTimezone, formatAustralianCurrency } from "@utils/commonFunctions";
import { Link } from "react-router-dom";

function TableListing(props) {
  const classes = TableStyle();
  const { timezone, getImpactJobBySurchargeBackDatedEventId } = props;
  const [state] = useStore();
  const [pagination, setPagination] = useState({
    page: 0,
    size: rowsPerPageVal
  });
  const [sort, setSort] = useState({
    order: "DESC",
    orderBy: "job"
  });
  let data = state?.customer?.impactJobData?.rows || [];
  let count = state?.customer?.impactJobData?.count ?? 0

  const handleChangePage = (event, newPage) => {
    setPagination((prev) => (
      {
        ...prev,
        page: newPage
      }
    ));
    const payload = {
      ...pagination,
      ...sort,
      page: newPage + 1
    };
    getImpactJobBySurchargeBackDatedEventId(payload);
  };

  const handleChangeRowsPerPage = (event) => {
    setPagination(prev => (
      {
        ...prev,
        size: parseInt(event.target.value, 10),
        page: 0
      }
    ));

    const payload = {
      ...pagination,
      ...sort,
      page: 1,
      size: parseInt(event.target.value, 10),
    };
    getImpactJobBySurchargeBackDatedEventId(payload);
  };

  const handleSorting = (event, property) => {
    const isAsc = sort.orderBy === property.sortTitle && sort.order === "asc";
    setSort(prev => (
      {
        ...prev,
        order: isAsc ? "desc" : "asc",
        orderBy: property.sortTitle
      }
    ));
    resetPagination();
    const payload = {
      page: 1,
      size: rowsPerPageVal,
      order: isAsc ? "desc" : "asc",
      orderBy: property.sortTitle
    };
    getImpactJobBySurchargeBackDatedEventId(payload);
  }

  const resetPagination = () => {
    setPagination(prev => (
      {
        ...prev,
        page: 0,
        rowsPerPage: rowsPerPageVal
      }
    ));
  };
  return (
    <div className={classes.TableWrapper}>
      <TableContainer component={Paper} className={classes.customTable}>
        <Table stickyHeader aria-label="simple table">
          <TableHead>
            <TableRow>
              {impactedJobsListingHeader.map((item, index) => (
                <TableCell key={index} className={item.className}>
                  <span>{item.title}</span>
                  {item.sort && (
                    <TableSortLabel
                      direction={sort.orderBy === item.sortTitle ? sort.order : "desc"}
                      active={true}
                      onClick={(e) => handleSorting(e, item)}
                    />
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {
              data.map((item) => {
                return (
                  <TableRow key={item.id}>
                    <TableCell className="job">
                      <Link to={`${routes.jobDetail}/${item?.jobId}`}>
                        {item?.jobId}
                      </Link>
                    </TableCell>
                    <TableCell className="jobDate">{utcToTimezone(item?.jobs?.completedAt, timezone, "DD-MM-YYYY") ?? "-"}</TableCell>
                    <TableCell className="previousRate">{item?.fuelSurcharges?.fuelSurcharge ?? "0"}%</TableCell>
                    <TableCell className="originalJobCharge">{Number(item?.originalCharge) === 0 ? "-" : formatAustralianCurrency(item?.originalCharge)}</TableCell>
                    <TableCell className="newJobCharge">{item?.isReCalculated ? formatAustralianCurrency(item?.jobs?.net) : "-"}</TableCell>
                    <TableCell className="difference">{item?.isReCalculated ? formatAustralianCurrency(item?.jobs?.net - item?.originalCharge) : "-"}</TableCell>
                  </TableRow>
                );
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
      {count !== 0 && (
        <div className="pagination-wrapper">
          <Pagination
            count={count}
            page={pagination.page}
            handleChangePage={handleChangePage}
            rowsPerPage={pagination.size}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </div>
      )}
    </div>
  );
}

export default TableListing;
